
import {Component, Mixins} from "vue-property-decorator"
import Common from '@/mixins/common'
import { getDocs, query, where } from "firebase/firestore"
import { SchedulingEntry, SchedulingSheet } from "@/common-datatypes"
import { UserSentMessage } from "@/scripts/datatypes"

type SchedulingResponseStatus = {
  sheetId: string;
  title: string;
  entryUserIds: string[];
  entryMeta: {
    [key: string]: SchedulingEntry['userMeta'];
  };
  receiverUserIds: UserSentMessage['receiverUserIds'];
  receiverMeta: UserSentMessage['receiverMeta'];
}

@Component({
  components: {
  }
})

export default class NotificationScheduling extends Mixins(Common){
  get userId(){
    return this.$store.getters.userId
  }

  isShow = true

  schedulingResponseStatus = [] as SchedulingResponseStatus[]

  async created(){
    //TODO: 公開しているshchedulingSheetの一覧を取得する
    const schedulingSheetsDocsRef =  query(this.$getSchedulingSheetsColRef(), where('postStatus', '==', 'publish'))

    const schedulingSheetsDocs = await getDocs(schedulingSheetsDocsRef)

    schedulingSheetsDocs.forEach(async (schedulingSheetDoc) => {
      const sheet = schedulingSheetDoc.data() as SchedulingSheet
      if(sheet){
        const sheetId = schedulingSheetDoc.id

        const sentMessageQuery = query(this.$getReferenceObjectUserSentMessageQuery([sheetId]),where('status','==','sent'))

        const sentMessageDocs = await getDocs(sentMessageQuery)

        let receiverUserIds: string[] = []
        let receiverMeta = {} as UserSentMessage['receiverMeta']
        const entryUserIds: string[] = []
        const entryMeta = {} as SchedulingResponseStatus['entryMeta']

        sentMessageDocs.forEach((sentMessageDoc) => {
          const row = sentMessageDoc.data() as UserSentMessage
          receiverUserIds = Array.from(new Set(receiverUserIds.concat(row.receiverUserIds || [])))
          receiverMeta = {
            ...receiverMeta,
            ...row.receiverMeta
          }
        })

        const schedulingEntriesQuery = this.$getSchedulingEntriesQuery(sheetId)

        const schedulingEntriesDocs = await getDocs(schedulingEntriesQuery)

        schedulingEntriesDocs.forEach((schedulingEntryDoc) => {
          const row = schedulingEntryDoc.data() as SchedulingEntry

          const entryUserId = row.userId

          entryUserIds.push(entryUserId)
          entryMeta[entryUserId] = row.userMeta
        })
        this.schedulingResponseStatus.push({
          sheetId,
          title: sheet.title,
          receiverUserIds,
          receiverMeta,
          entryUserIds,
          entryMeta
        })
      }
    })
  }
}
